var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6FD50A",
    d: "M84.446 63.724V34.425a9.04 9.04 0 0 0-4.52-7.828l-25.374-14.65a9.04 9.04 0 0 0-9.04 0L20.14 26.597a9.04 9.04 0 0 0-4.52 7.828v29.3a9.04 9.04 0 0 0 4.52 7.828l25.373 14.65a9.04 9.04 0 0 0 9.04 0l25.374-14.65a9.04 9.04 0 0 0 4.52-7.829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#94ED3B",
    d: "M82.522 62.905v-27.66a8.54 8.54 0 0 0-4.267-7.392L54.3 14.023a8.53 8.53 0 0 0-8.535 0L21.81 27.853a8.54 8.54 0 0 0-4.268 7.391v27.661a8.53 8.53 0 0 0 4.268 7.392l23.955 13.83a8.53 8.53 0 0 0 8.535 0l23.955-13.83a8.54 8.54 0 0 0 4.267-7.392"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4FBCE",
    d: "M78.99 61.402V36.748a7.6 7.6 0 0 0-3.804-6.588l-21.35-12.326a7.6 7.6 0 0 0-7.606 0L24.88 30.16a7.6 7.6 0 0 0-3.804 6.588v24.654a7.6 7.6 0 0 0 3.804 6.587l21.35 12.326a7.6 7.6 0 0 0 7.606 0l21.35-12.326a7.6 7.6 0 0 0 3.804-6.588"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#98D393",
    d: "M62.15 54.057c-.339.292-.639.638-.965.948-3.17 3.005-7.693 5.44-12.138 5.612l-.446.017h-.437c-5.37-.142-10.777-3.245-14.178-7.296-.562-.669-1.695-2.154-1.732-3.023-.035-.77.88-2.056 1.348-2.66 2.773-3.573 7.483-6.64 11.95-7.492 6.299-1.2 12.238 1.834 16.517 6.234.04.04.027.09.107.053 0 0 1.979 3.032-.026 7.607"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4EA254",
    d: "m69.575 43.073-1.586 7.186 1.586 7.188v.255c-.156.776-1.118 1.096-1.746.645l-5.68-4.29c2.006-4.574.027-7.605.027-7.605l5.653-4.28c.572-.46 1.65-.105 1.746.646.01.079-.008.174 0 .255"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.007,
    d: "M39.949 47.395a1.697 1.697 0 1 0 3.393 0 1.697 1.697 0 1 0-3.393 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("mask", {
    id: "starter_svg__a",
    width: 58,
    height: 66,
    x: 21,
    y: 16,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.99 61.423V36.764c0-2.718-1.45-5.23-3.804-6.588l-21.355-12.33a7.61 7.61 0 0 0-7.609 0l-21.355 12.33a7.61 7.61 0 0 0-3.803 6.589v24.658c0 2.719 1.45 5.23 3.803 6.589l21.355 12.33a7.61 7.61 0 0 0 7.61 0l21.354-12.33a7.61 7.61 0 0 0 3.804-6.589"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F1FDE7",
    mask: "url(#starter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.102-9.714-66.37 51.389 13.25 17.111 66.37-51.388zM71.445 10.203 5.075 61.59l3.352 4.328 66.37-51.388z"
  })))));
};
export default SvgStarter;